
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.063 3.969S22.508 6 16.124 6c-6.39 0-10.25-1.969-10.25-1.969l-.906 1.782S6.832 6.726 10 7.375v17.219c-3.223.668-5.063 1.656-5.063 1.656l.97 1.75s3.581-2 9.968-2c6.39 0 10.281 1.969 10.281 1.969l.907-1.782S25.18 25.273 22 24.625V7.406c3.2-.676 5.031-1.687 5.031-1.687zM12 7.719A30.71 30.71 0 0016.125 8c1.418 0 2.703-.094 3.875-.25v16.531A30.755 30.755 0 0015.875 24c-1.418 0-2.703.094-3.875.25z"}})])
          )
        }
      }
    